(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-progress"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root =
    document.currentScript?.closest('.timeline-progress') ||
    document.querySelector('.timeline-progress');

  if (!root || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  /* ===============================
     ELEMENTS
  =============================== */
  const slides = [...root.querySelectorAll('.tp-slide')];
  const media = [...root.querySelectorAll('.tp-media')];
  const pills = [...root.querySelectorAll('.tp-pill')];
  const pillsContainer = root.querySelector('.tp-pills');
  const prevBtn = root.querySelector('.tp-prev');
  const nextBtn = root.querySelector('.tp-next');
  const circle = root.querySelector('.tp-circle');
  const rail = root.querySelector('.tp-line-rail');
  const yearLabel = root.querySelector('.tp-year-value');
  const yearLine = root.querySelector('.tp-line');
  const yearWrap = root.querySelector('.tp-yearline-overlay');

  /* Mobile-only animated blocks */
  const mobileSlideEls = [
    yearWrap,
    root.querySelector('.tp-right'),
    root.querySelector('.tp-slide-stack')
  ].filter(Boolean);

  const isMobile = window.matchMedia('(max-width: 1024px)').matches;

  let current = 0;
  let previous = 0;
  let hasScrollPlayed = false;
  let progressTween = null;

  /* ===============================
     PROGRESS RING
  =============================== */
  const PROGRESS_DURATION = 7;

  const resetProgress = () => {
    if (progressTween) progressTween.kill();
    pills.forEach(p => p.style.setProperty('--progress-angle', '0deg'));
  };

  const startProgress = (index) => {
    resetProgress();
    const pill = pills[index];
    if (!pill) return;

    const state = { angle: 0 };

    progressTween = gsap.to(state, {
      angle: 360,
      duration: PROGRESS_DURATION,
      ease: 'linear',
      onUpdate: () => {
        pill.style.setProperty('--progress-angle', `${state.angle}deg`);
      },
      onComplete: () => setActive(current + 1, 1)
    });
  };

  /* ===============================
     PILL AUTO SCROLL
  =============================== */
  const scrollPillIntoView = (pill) => {
    if (!pill || !pillsContainer) return;

    const pillRect = pill.getBoundingClientRect();
    const containerRect = pillsContainer.getBoundingClientRect();

    pillsContainer.scrollBy({
      left:
        pillRect.left -
        containerRect.left -
        (containerRect.width / 2 - pillRect.width / 2),
      behavior: 'smooth'
    });
  };

  /* ===============================
     DESKTOP ANIMATIONS
  =============================== */
  const animateText = (el, dir) => {
    if (!el) return;
    gsap.killTweensOf(el);

    gsap.fromTo(
      el,
      { y: dir === 1 ? 40 : -40, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: "power3.out" }
    );
  };

  const animateMedia = (el, dir) => {
    if (!el) return;
    gsap.killTweensOf(el);

    gsap.fromTo(
      el,
      { y: dir === 1 ? "100%" : "-100%" },
      { y: "0%", duration: 1.2, ease: "power3.out" }
    );
  };

  /* ===============================
     CORE SLIDE CHANGE
  =============================== */
  const setActive = (index, navDir = 0) => {
    if (!hasScrollPlayed) return;

    const total = slides.length;
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;

    const direction = navDir !== 0 ? navDir : index > current ? 1 : -1;

    previous = current;
    current = index;

    /* =========================
       MOBILE YEAR LINE (STABLE)
    ========================= */
    if (isMobile && yearLine && yearWrap) {
      yearLine.classList.remove('is-start');
      yearWrap.classList.remove('is-start');

      if (current === 0) {
        yearLine.classList.add('is-start');
        yearWrap.classList.add('is-start');
      }
    }

    /* =========================
       MOBILE SLIDE ANIMATION
    ========================= */
    if (isMobile && mobileSlideEls.length) {
      const fromX = direction === 1 ? '100%' : '-100%';

      gsap.fromTo(
        mobileSlideEls,
        { x: fromX },
        { x: '0%', duration: 0.45, ease: 'power2.out' }
      );
    }

    /* =========================
       STATE UPDATE
    ========================= */
    slides.forEach((s, i) => s.classList.toggle('is-active', i === current));

    media.forEach((m, i) => {
      m.classList.remove('is-active', 'is-prev');
      if (i === previous) m.classList.add('is-prev');
      if (i === current) m.classList.add('is-active');
    });

    pills.forEach((p, i) => {
      p.classList.toggle('is-active', i === current);
      p.setAttribute('aria-selected', i === current);
    });

    scrollPillIntoView(pills[current]);

    const pillLabel = pills[current]?.querySelector('.tp-pill-label')?.textContent;
    if (yearLabel && pillLabel) yearLabel.textContent = pillLabel;

    /* =========================
       DESKTOP ONLY
    ========================= */
    if (!isMobile) {
      animateText(yearLabel, direction);
      animateText(slides[current]?.querySelector('.tp-info-title-value'), direction);
      animateText(slides[current]?.querySelector('.tp-footnote-value'), direction);
      animateMedia(media[current]?.querySelector('.tp-media-border'), direction);
    }

    startProgress(current);
  };

  /* ===============================
     NAVIGATION
  =============================== */
  pills.forEach(pill =>
    pill.addEventListener('click', () =>
      setActive(+pill.dataset.index, pill.dataset.index > current ? 1 : -1)
    )
  );

  prevBtn?.addEventListener('click', () => setActive(current - 1, -1));
  nextBtn?.addEventListener('click', () => setActive(current + 1, 1));
  circle?.addEventListener('click', () => setActive(current + 1, 1));
  rail?.addEventListener('click', () => setActive(current + 1, 1));

  /* ===============================
     MOBILE SWIPE
  =============================== */
  if (isMobile) {
    const swipeTarget = root.querySelector('.tp-right');
    if (!swipeTarget) return;

    let startX = 0;
    let endX = 0;

    swipeTarget.addEventListener('touchstart', e => {
      if (!hasScrollPlayed) return;
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    swipeTarget.addEventListener('touchend', e => {
      if (!hasScrollPlayed) return;
      endX = e.changedTouches[0].clientX;

      const diff = startX - endX;
      if (Math.abs(diff) < 60) return;

      diff > 0
        ? setActive(current + 1, 1)
        : setActive(current - 1, -1);
    }, { passive: true });
  }

  /* ===============================
     INITIAL STATE
  =============================== */
  slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));
  media.forEach((m, i) => m.classList.toggle('is-active', i === 0));
  pills.forEach((p, i) => p.classList.toggle('is-active', i === 0));

  if (isMobile && yearLine && yearWrap) {
    yearLine.classList.add('is-start');
    yearWrap.classList.add('is-start');
  }

  /* ===============================
     SCROLL ENTRY
  =============================== */
  ScrollTrigger.create({
    trigger: root,
    start: "top 65%",
    once: true,
    onEnter: () => {
      hasScrollPlayed = true;

      if (!isMobile) {
        animateText(yearLabel, 1);
        animateText(slides[0]?.querySelector('.tp-info-title-value'), 1);
        animateText(slides[0]?.querySelector('.tp-footnote-value'), 1);
        animateMedia(media[0]?.querySelector('.tp-media-border'), 1);
      }

      startProgress(0);
      scrollPillIntoView(pills[0]);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
